function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInvitesAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.185 218.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.445,217.503S-16.148,162.581,6.134,106.04c14.524-36.855,69.007-57.05,99.754-36.855,13.096,8.601,55.11.29,77.543-35.32,43.593-69.198,195.734-27.173,168.036,79.07-13.404,51.414,40.793,53.283,13.178,104.676l-335.2-.109Z",
    style: {
      fill: "#e4ebfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.945,217.482l-.059-.007c-.709-.088-1.211-.72-1.121-1.413l12.328-83.448,4.513.129-14.505,83.899c-.093.537-.603.908-1.156.839Z",
    style: {
      fill: "#00294f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.888,217.11l.093-.002c.763-.014,1.353-.638,1.281-1.355l-5.091-50.845-4.443.396,7.31,51.119c.057.399.422.695.849.687Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.865,217.11l-.093-.002c-.763-.014-1.353-.638-1.281-1.355l5.091-50.845,4.443.396-7.31,51.119c-.057.399-.422.695-.849.687Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.805,217.11l.093-.002c.763-.014,1.352-.638,1.281-1.355l-5.091-50.845-4.443.396,7.31,51.119c.057.399.422.695.849.687Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.381,157.512l-9.037-44.628c-1.16-6.042,3.847-11.567,10.348-11.419l17.429.398c6.012.137,11.24,4.161,12.911,9.939l13.222,45.71h-44.873Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.848,157.512l-9.037-44.628c-1.16-6.042,3.847-11.567,10.348-11.419l17.429.398c6.012.137,11.24,4.161,12.911,9.939l13.222,45.71h-44.873Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.337,157.512h70.08c1.08,0,1.957.877,1.957,1.957v6.183h-72.036c-1.08,0-1.957-.877-1.957-1.957v-4.226c0-1.08.877-1.956,1.956-1.956Z",
    transform: "translate(290.754 323.163) rotate(180)",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.229,
    y: 157.512,
    width: 48.015,
    height: 8.139,
    rx: 1.956,
    ry: 1.956,
    transform: "translate(330.474 323.163) rotate(180)",
    style: {
      fill: "#78b4f6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.806,156.93v1.522c0,.533-.173.968-.383.968H31.862c-.211,0-.383-.435-.383-.968v-1.522c0-.532.173-.968.383-.968h55.561c.211,0,.383.436.383.968Z",
    style: {
      fill: "#d0d3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.806,156.93v1.522c0,.533-.158.968-.352.968h-44.11c-.193,0-.352-.435-.352-.968v-1.522c0-.532.158-.968.352-.968h44.11c.193,0,.352.436.352.968Z",
    style: {
      fill: "#a7aaad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.299,
    y: 159.422,
    width: 39.445,
    height: 57.493,
    style: {
      fill: "#e5e7e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.353,
    y: 159.422,
    width: 39.445,
    height: 57.493,
    style: {
      fill: "#f0f1f1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.679,213.741h-35.206v-52.695h35.206v52.695ZM47.853,213.36h34.446v-51.934h-34.446v51.934Z",
    style: {
      fill: "#a7aaad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.663,
    y: 178.478,
    width: 34.826,
    height: 0.38,
    style: {
      fill: "#a7aaad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.663,
    y: 196.249,
    width: 34.826,
    height: 0.38,
    style: {
      fill: "#a7aaad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.644,164.444h-6.462c-.314,0-.57-.257-.57-.57h0c0-.314.257-.57.57-.57h6.462c.314,0,.57.257.57.57h0c0,.314-.257.57-.57.57Z",
    style: {
      fill: "#a7aaad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.644,181.823h-6.462c-.314,0-.57-.257-.57-.57h0c0-.314.257-.57.57-.57h6.462c.314,0,.57.257.57.57h0c0,.314-.257.57-.57.57Z",
    style: {
      fill: "#a7aaad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.644,199.939h-6.462c-.314,0-.57-.257-.57-.57h0c0-.314.257-.57.57-.57h6.462c.314,0,.57.257.57.57h0c0,.314-.257.57-.57.57Z",
    style: {
      fill: "#a7aaad"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168.451,148.172c-3.73,6.493-8.422,8.999-8.422,8.999h-19.52s30.788-13.952,27.942-8.999Z",
    style: {
      fill: "#0c3563"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.527,212.676c-.211,2.048,2.638,2.577,5.941,2.777,3.304.2,2.298.866,6.819,1.735,4.521.869,6.35-.351,6.684-.96.298-.54-1.799-1.412-4.033-2.396-.281-.123-.563-.249-.844-.376-2.514-1.138-3.907-3.418-5.854-5.54-1.844-2.009-3.547-8.398-3.547-8.398l-6.142-1.381s1.667,5.752,2.241,8.206c.337,1.443-.201,3.047-.676,4.267-.256.664-.515,1.343-.589,2.065Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.468,215.453c3.304.2,2.298.866,6.819,1.735,4.521.869,6.35-.351,6.684-.96.298-.54-1.799-1.412-4.033-2.396l-.035.038s-3.197,1.047-6.862.008c-2.988-.846-5.866-2.668-7.924-3.268-.256.664-.515,1.343-.589,2.065-.211,2.048,2.638,2.577,5.941,2.777Z",
    style: {
      fill: "#002049"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.222,141.522c-3.305-2.321-25.165-6.458-36.321-7.654l-12.331-10.704s-10.496,15.545-10.579,27.438c-.039,5.545,2.515,6.096,2.516,6.097,0,0,39.528.293,41.261.472,2.836.292,6.577,7.358,7.512,13.793.935,6.435,17.418,32.609,17.418,32.609,0,0,3.438,1.101,5.027,1.008,1.71-.1,2.501-.673,2.501-.673,0,0-9.552-57.153-17.005-62.386Z",
    style: {
      fill: "#313746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.302,212.676c-.211,2.048,2.638,2.577,5.941,2.777,3.304.2,2.297.866,6.818,1.735,4.521.869,6.35-.351,6.684-.96.298-.54-1.799-1.412-4.033-2.396-.281-.123-.563-.249-.844-.376-2.514-1.138-3.907-3.418-5.854-5.54-1.844-2.009-3.547-8.398-3.547-8.398l-6.142-1.381s1.667,5.752,2.241,8.206c.337,1.443-.201,3.047-.676,4.267-.256.664-.515,1.343-.589,2.065Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.244,215.453c3.304.2,2.297.866,6.818,1.735,4.521.869,6.35-.351,6.684-.96.298-.54-1.799-1.412-4.033-2.396l-.035.038s-3.197,1.047-6.862.008c-2.988-.846-5.866-2.668-7.924-3.268-.256.664-.515,1.343-.589,2.065-.211,2.048,2.638,2.577,5.941,2.777Z",
    style: {
      fill: "#0c3563"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.907,141.522c-2.871-2.016-11.506-3.579-21.038-4.739-2.635-.321-4.799-2.237-5.443-4.812h0l-22.171-8.806s-10.496,15.545-10.579,27.438c-.039,5.545,2.515,6.096,2.516,6.097,0,0,39.528.293,41.261.472,2.836.292,6.577,7.358,7.512,13.793.935,6.435,17.418,32.609,17.418,32.609,0,0,3.437,1.101,5.027,1.008,1.71-.1,2.501-.673,2.501-.673,0,0-9.552-57.153-17.005-62.386Z",
    style: {
      fill: "#3b4156"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.239,58.575c-3.047-1.6-7.682-1.816-8.436-1.917-9.012-1.211-14.437,11.885-14.756,15.853-.588,7.314-4.457,8.429-9.903,13.01-10.92,9.185-7.718,19.857-1.747,23.823,3.583,2.379,9.898,0,9.898,0,.089.062,17.27-9.605,25.74-14.268,12.696-1.805,6.968-32.423-.796-36.5Z",
    style: {
      fill: "#6d6766"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,90.57c.039.02-4.004,1.859-6.924.895-2.746-.905-5.165-5.04-5.126-5.046,1.192-.173,2.404-1.349,2.742-8.317l.528.133,8.875,2.243s-.351,2.812-.496,5.47c-.122,2.232-.097,4.356.401,4.621Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.454,80.479s0,.579-.332,3.194c-5.019-1.266-7.233-2.93-8.793-4.835l9.125,1.641Z",
    style: {
      fill: "#ff9759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.348,80.833s-11.736,1.911-12.814-5.416c-1.077-7.327-3.318-12.015,4.13-13.545,7.448-1.53,9.318,1.051,10.272,3.41.954,2.358,1.436,14.865-1.589,15.551Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.359,61.565s-5.33,8.413-10.088,10.405c-4.758,1.993-7.095.981-7.095.981,0,0,2.165-3.282,2.729-7.689.166-1.299,1.012-2.413,2.228-2.9,3.414-1.367,10.019-3.524,12.226-.798Z",
    style: {
      fill: "#6d6766"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.677,62.378s3.124,1.602,4.41,3.103c1.241,1.448,2.675,5.379,2.573,7.144,0,0,1.541-8.459-1.669-11.366-3.403-3.083-5.315,1.12-5.315,1.12Z",
    style: {
      fill: "#6d6766"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.749,108.47c-.356,23.856-.098,18.871-2.707,21.134-.629.545-2.396.87-4.723,1.023-7.315.486-20.174-.72-20.663-2.071-1.687-4.678-.496-6.131-1.904-13.292-.147-.761-.328-1.586-.541-2.484-1.174-4.919-2.316-6.592,1.848-14.494,3.776-7.158,8.217-12.972,8.57-12.763,9.963,5.914,10.304.957,10.304.957,0,0,9.991,10.353,9.817,21.989Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.932,86.481s10.197,1.728,11.4,6.142c1.204,4.414,8.288,30.362,8.288,30.362,0,0-5.211.936-7.619-1.471s-8.377-22.337-8.377-22.337l-3.692-12.696Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.318,130.628c-7.315.486-20.174-.72-20.663-2.071-1.687-4.678-.496-6.131-1.904-13.292l3.528-9.935s-.583,11.063,2.679,13.973c3.259,2.91,13.358,5.617,14.944,8.049.765,1.167,1.268,2.337,1.415,3.277Z",
    style: {
      fill: "#e7f2ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.937,125.975s7.217-1.607,8.381-.966c1.164.64,4.01,2.973,4.367,3.784.356.812-2.592-.616-3.552-.873-.621-.167-2.256.402-3.066.671-3.406,1.135-5.493.551-5.493.551l-.638-3.167Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.628,85.524s-10.214.597-13.568,5.276c-4.722,6.586-14.089,34.654-8.721,38.397,6.046,4.216,27.516,1.103,27.516,1.103,0,0,.715-3.34-.28-4.955-.994-1.616-17.148-4.225-17.894-4.971-.746-.746,9.32-14.539,9.32-16.776s3.627-18.075,3.627-18.075Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.668,127.017s1.512,1.95,2.008,2.183c.496.233.816.175.816.175l-1.019-1.834-1.805-.524Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.318,125.008l4.396,2.135s-.187.306-.728.281c-.541-.025-1.907-.524-1.907-.524l-1.761-1.892Z",
    style: {
      fill: "#ffb27b"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.513,130.069h-20.418c0-.899.729-1.628,1.628-1.628h18.791v1.628Z",
    style: {
      fill: "#939599"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.455 107.832 191.023 107.832 183.451 130.069 151.678 130.069 159.455 107.832",
    style: {
      fill: "#939599"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.487 107.832 183.916 130.069 152.143 130.069 159.92 107.832 191.487 107.832",
    style: {
      fill: "#e5e7e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.468,118.745c-.196.85-1.044,1.538-1.894,1.538s-1.379-.689-1.183-1.538c.196-.85,1.044-1.538,1.894-1.538s1.379.689,1.183,1.538Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 130.984,
    y: 130.069,
    width: 140.447,
    height: 5.003,
    rx: 1.203,
    ry: 1.203,
    style: {
      fill: "#00294f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.765,217.482l.059-.007c.709-.088,1.211-.72,1.121-1.413l-12.328-83.448-4.513.129,14.505,83.899c.093.537.603.908,1.156.839Z",
    style: {
      fill: "#00294f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.405,217.482l-.059-.007c-.709-.088-1.211-.72-1.121-1.413l12.328-83.448,4.513.129-14.505,83.899c-.093.537-.603.908-1.156.839Z",
    style: {
      fill: "#00294f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.694,
    width: 384.185,
    height: 1.476,
    rx: 0.355,
    ry: 0.355,
    style: {
      fill: "#263252"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.674,217.415h24.463c1.177-1.436.743-6.734.565-8.464-.037-.348-.062-.552-.062-.552,0,0-8.354-6.682-9.501-1.565-.035.161-.077.317-.124.472-1.446,4.785-7.93,6.96-11.674,7.566-2.434.395-3.334,1.66-3.667,2.543Z",
    style: {
      fill: "#0c3563"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.424,137.926c-.883,0-41.904,7.702-48.689,16.101-3.39,4.196-3.893,52.654-3.893,52.654,0,0,4.194,5.199,13.25,2.18,0,0,6.64-33.154,6.15-43.21-.136-2.781,28.027-.402,33.182-1.736,5.155-1.334,17.749-12.547,14.974-18.01-2.775-5.463-14.974-7.979-14.974-7.979Z",
    style: {
      fill: "#0a707b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.912,126.06s-8.274.112-10.231.95c-1.957.839-5.926,2.764-4.864,3.059,1.062.295,6.131-.122,7.226.046,1.095.168,2.446-.046,3.117-.046.671,0,3.8,0,3.8,0l.952-4.009Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.237,106.203s-2.821-2.016-5.561-2.407c-1.562-.223-3.082-.502-4-.825-2.528-.891-7.585-5.438-7.203-5.972,1.227-1.71,7.131,1.908,8.162,1.52,1.03-.388-1.981-2.53-.933-3.283.547-.393,1.827,1.578,2.873,1.776,1.415.268,2.522,2.267,2.948,2.371.829.203,4.462,2.905,4.462,2.905l-.749,3.915Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.96,124.997v5.072h30.509s11.44-10.882,14.87-18.208c3.43-7.326,0-29.2,0-29.2,0,0-6.299,1.952-12.504,19.041-6.206,17.089-8.563,18.012-10.818,18.683-2.256.671-22.056,4.613-22.056,4.613",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.862,217.415h24.463c1.177-1.436.743-6.734.565-8.464-.037-.348-.062-.552-.062-.552,0,0-8.354-6.682-9.501-1.565-.035.161-.077.317-.124.472-1.446,4.785-7.93,6.96-11.674,7.566-2.434.395-3.334,1.66-3.667,2.543Z",
    style: {
      fill: "#002c51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.336,137.926c-.883,0-41.904,7.702-48.689,16.101-3.39,4.196-3.893,52.654-3.893,52.654,0,0,4.194,5.199,13.25,2.18,0,0,6.64-33.154,6.15-43.21-.136-2.781,28.027-.402,33.182-1.736,5.155-1.334,17.749-12.547,14.974-18.01-2.775-5.463-14.974-7.979-14.974-7.979Z",
    style: {
      fill: "#3999ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.904,88.077c2.951-.244,6.045-1.03,8.719-1.898,3.343-1.085,6.037-2.67,4.301-5.725-1.6-2.816-4.19-9.106-4.015-14.317l-6.22,5.013-4.225,3.404s.017,2.007.479,5.525c.084.641.183,1.333.3,2.073.094.598-.181,1.194-.695,1.513-.032.02-.064.04-.095.059-2.1,1.319-1.02,4.556,1.452,4.352Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.463,73.726s-.216.729.155,3.42c3.767-.614,7.288-3.619,7.288-3.619-1.918-.526-2.616-2.599-4.044-2.406l-3.4,2.604Z",
    style: {
      fill: "#ff9759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.979,74.339s14.49,2.407,15.85-6.639c1.36-9.046,4.146-14.828-5.047-16.748-9.194-1.919-11.514,1.262-12.703,4.171-1.188,2.909-1.834,18.357,1.9,19.216Z",
    style: {
      fill: "#ffb27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.947,51.12c-.622,2.178,1.043,4.832,3.838,5.705,4.149,1.297,3.232,6.386,5.1,6.317,1.867-.069,2.62-2.926,4.288-.643,1.423,1.947-1.184,4.254-1.005,5.322.308,1.833,3.179,5.582,5.766,5.394,2.587-.188,7.428-12.483,6.46-16.286-.968-3.804-4.841-7.815-8.506-8.368-3.665-.553-8.755,1.029-9.931,1.029s-5.673.353-6.009,1.529Z",
    style: {
      fill: "#0d0a07"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.591,95.216c-2.094-8.429-7.883-17.274-11.796-17.266-6.669.013-16.256,1.773-20.127,11.322-2.851,7.033-6.654,47.489-2.356,50.366,9.825,6.577,32.598,20.004,36.643,6.312,3.707-12.546,1.271-36.103-2.364-50.733Z",
    style: {
      fill: "#737a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.393,86.828c-1.903-4.949-8.039-6.66-12.224-3.404-2.263,1.761-5.035,4.269-8.383,7.834-12.446,13.254-14.975,13.171-17.313,12.897-2.338-.274-22.086-4.465-22.086-4.465,0,0-1.011.746-1.606,1.952-.795,1.611-.395,2.708-.395,2.708-.774-.5,7,4.859,10.87,6.996,5.11,2.822,12.81,5.467,15.877,6.472.869.285,1.807.27,2.667-.04,4.552-1.641,19.839-7.62,32.283-17.994,3.279-2.733,2.074-8.367.31-12.955Z",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.466,78.031l-1.51-3.402s-13.515,1.102-15.787,8.795c0,0,10.477-5.228,17.297-5.393Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.28,217.11l.093-.002c.763-.014,1.353-.638,1.281-1.355l-5.091-50.845-4.443.396,7.31,51.119c.057.399.422.695.849.687Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.075,217.11l.093-.002c.763-.014,1.353-.638,1.281-1.355l-5.091-50.845-4.443.396,7.31,51.119c.057.399.422.695.849.687Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.879,217.11l-.093-.002c-.763-.014-1.353-.638-1.281-1.355l5.091-50.845,4.442.396-7.31,51.119c-.057.399-.422.695-.849.687Z",
    style: {
      fill: "#57a2e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.841,157.705l4.832-42.467c.634-6.12-1.414-12.112-10.246-12.576l-15.536-.946c-9.208-.38-13.366,7.284-14.532,13.184l-9.223,46.682,44.705-3.877Z",
    style: {
      fill: "#78b4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.728,157.512h72.036v6.183c0,1.08-.877,1.956-1.956,1.956h-70.08c-1.08,0-1.956-.877-1.956-1.956v-4.226c0-1.08.877-1.956,1.956-1.956Z",
    style: {
      fill: "#57a2e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.093,157.512h42.671v6.183c0,1.08-.877,1.957-1.957,1.957h-40.714c-1.08,0-1.956-.877-1.956-1.956v-4.226c0-1.08.877-1.956,1.956-1.956Z",
    style: {
      fill: "#78b4f6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.861,102.817c-.051-.213.204-.364.369-.22,1.668,1.463,5.707,5.878,5.009,13.856-.876,10.01,1.324,13.577,3.984,15.708,0,0-3.585-.923-5.944-4.538-5.791-8.876-2.517-21.027-3.418-24.807Z",
    style: {
      fill: "#8ac440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.197,105.889c.24,1.103.458,2.21.635,3.323.183,1.112.332,2.23.447,3.35.11,1.121.199,2.243.24,3.368.046,1.125.044,2.25.038,3.379,0,1.129-.006,2.267.104,3.408.109,1.139.356,2.284.804,3.349.112.266.229.53.361.785.127.258.266.51.409.759.289.498.611.977.967,1.43.715.905,1.567,1.7,2.498,2.365.098.07.234.047.304-.051.069-.096.048-.229-.045-.301h0c-.222-.169-.442-.34-.653-.519-.107-.088-.21-.181-.315-.272-.101-.095-.206-.186-.304-.283-.399-.384-.77-.796-1.11-1.233-.682-.87-1.237-1.846-1.668-2.864-.209-.511-.381-1.037-.511-1.574-.13-.537-.219-1.085-.276-1.639-.115-1.108-.119-2.234-.127-3.363-.01-1.129-.027-2.264-.091-3.396-.031-.566-.071-1.132-.122-1.696-.024-.282-.053-.564-.082-.846-.031-.282-.064-.563-.1-.844-.143-1.124-.321-2.243-.533-3.355-.218-1.111-.465-2.216-.755-3.309-.008-.031-.04-.05-.072-.042-.03.008-.049.039-.042.069Z",
    style: {
      fill: "#fff",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.882,135.252c-.101.39-.567.55-.889.308-1.778-1.333-6.464-5.555-6.764-13.219-.254-6.472-1.006-9.957-1.458-11.516-.095-.33.285-.589.558-.381,3.006,2.3,12.214,10.683,8.553,24.808Z",
    style: {
      fill: "#8ac440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.339,135.306c-.008.006-.016.012-.025.017-.077.041-.172.011-.212-.065-.046-.087-4.614-8.802-5.373-17.785-.007-.086.057-.163.143-.17.087-.007.163.057.17.143.754,8.918,5.292,17.578,5.338,17.664.036.068.017.149-.04.196Z",
    style: {
      fill: "#fff",
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.859,
    y: 127.447,
    width: 19.261,
    height: 28.523,
    rx: 4.63,
    ry: 4.63,
    style: {
      fill: "#f0d5aa"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 230.49,
    cy: 44.579,
    r: 14.387,
    style: {
      fill: "#d71c5c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.059,
    cy: 44.471,
    r: 13.539,
    transform: "translate(-1.266 7.138) rotate(-1.773)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 230.49,
    cy: 44.579,
    r: 12.689,
    transform: "translate(173.323 272.273) rotate(-86.853)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.891,41.886c-5.778,3.501-15.275,9.244-20.583,12.392-1.489-1.257-2.684-2.85-3.467-4.662l17.555-16.27c3.269,1.721,5.694,4.829,6.495,8.54Z",
    style: {
      fill: "#ececec",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.137,45.593c-.117,1.482-.489,2.893-1.071,4.187l-14.899,7.046c-.745-.2-1.464-.469-2.149-.797,4.665-2.697,12.963-7.471,18.118-10.436Z",
    style: {
      fill: "#ececec",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "230.674 35.406 231.092 45.458 229.888 45.443 230.347 35.402 230.674 35.406",
    style: {
      fill: "#ffc800"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.482 44.49 231.306 43.973 231.287 45.177 223.477 44.817 223.482 44.49",
    style: {
      fill: "#375a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.901,44.579c0,.227-.184.411-.411.411s-.411-.184-.411-.411.184-.411.411-.411.411.184.411.411Z",
    style: {
      fill: "#c8c8c8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.124,33.054v1.153c0,.061-.051.107-.109.107-.061,0-.107-.047-.107-.107v-.961l-.078.045c-.018.012-.037.016-.055.016-.037,0-.072-.02-.092-.055-.033-.049-.016-.117.035-.147l.24-.143s.006-.002.008-.004c.004,0,.006-.004.01-.006.004,0,.008-.002.012-.002.002-.002.006-.002.008-.002.004-.002.01-.002.014-.002h.022s.006.002.008.002c.006,0,.008.002.012.004.002,0,.006,0,.008.002.006.004.008.006.012.006.002.002.004.004.008.006.002.002.006.004.008.006.004.002.006.006.008.008.002.002.004.004.006.008.002.002.006.006.008.008l.002.004s.002.004.002.006c.002.004.004.006.004.01.002.004.002.008.004.01,0,.004.002.008.002.01,0,.006,0,.01.004.014v.006Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.255,34.207c0,.061-.047.107-.107.107h-.696c-.029,0-.061-.012-.08-.035-.041-.045-.037-.111.006-.152l.578-.524c.057-.051.082-.117.082-.188,0-.063-.021-.121-.064-.17-.051-.057-.119-.082-.188-.082-.061,0-.121.021-.17.065l-.061.055c-.045.041-.111.037-.152-.008-.039-.045-.037-.111.008-.152l.061-.055c.088-.082.203-.121.315-.121.127,0,.256.053.348.154.082.088.121.203.121.315,0,.127-.053.256-.154.348l-.369.334h.416c.061,0,.107.049.107.109Z",
    style: {
      fill: "#1a2e35"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.04,34.493v1.153c0,.061-.051.107-.109.107-.061,0-.108-.047-.108-.107v-.961l-.078.045c-.018.012-.037.016-.055.016-.037,0-.072-.02-.092-.055-.033-.049-.016-.117.035-.147l.24-.143s.006-.002.008-.004c.004,0,.006-.004.01-.006.004,0,.008-.002.012-.002.002-.002.006-.002.008-.002.004-.002.01-.002.014-.002h.021s.006.002.008.002c.006,0,.008.002.012.004.002,0,.006,0,.008.002.006.004.008.006.012.006.002.002.004.004.008.006.002.002.006.004.008.006.004.002.006.006.008.008.002.002.004.004.006.008.002.002.006.006.008.008l.002.004s.002.004.002.006c.002.004.004.006.004.01.002.004.002.008.004.01,0,.004.002.008.002.01,0,.006,0,.01.004.014v.006Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.722,34.493v1.153c0,.061-.051.107-.109.107-.061,0-.107-.047-.107-.107v-.961l-.078.045c-.018.012-.037.016-.055.016-.037,0-.072-.02-.092-.055-.033-.049-.016-.117.035-.147l.24-.143s.006-.002.008-.004c.004,0,.006-.004.01-.006.004,0,.008-.002.012-.002.002-.002.006-.002.008-.002.004-.002.01-.002.014-.002h.022s.006.002.008.002c.006,0,.008.002.012.004.002,0,.006,0,.008.002.006.004.008.006.012.006.002.002.004.004.008.006.002.002.006.004.008.006.004.002.006.006.008.008.002.002.004.004.006.008.002.002.006.006.008.008l.002.004s.002.004.002.006c.002.004.004.006.004.01.002.004.002.008.004.01,0,.004.002.008.002.01,0,.006,0,.01.004.014v.006Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.376,34.493v1.153c0,.061-.051.107-.109.107-.061,0-.107-.047-.107-.107v-.961l-.078.045c-.018.012-.037.016-.055.016-.037,0-.072-.02-.092-.055-.033-.049-.016-.117.035-.147l.24-.143s.006-.002.008-.004c.004,0,.006-.004.01-.006.004,0,.008-.002.012-.002.002-.002.006-.002.008-.002.004-.002.01-.002.014-.002h.022s.006.002.008.002c.006,0,.008.002.012.004.002,0,.006,0,.008.002.006.004.008.006.012.006.002.002.004.004.008.006.002.002.006.004.008.006.004.002.006.006.008.008.002.002.004.004.006.008.002.002.006.006.008.008l.002.004s.002.004.002.006c.002.004.004.006.004.01.002.004.002.008.004.01,0,.004.002.008.002.01,0,.006,0,.01.004.014v.006Z",
    style: {
      fill: "#1a2e35"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.438,39.714c0,.061-.047.107-.108.107h-.696c-.029,0-.061-.012-.08-.035-.041-.045-.037-.111.006-.152l.578-.524c.057-.051.082-.117.082-.188,0-.063-.022-.121-.065-.17-.051-.057-.119-.082-.188-.082-.061,0-.121.021-.17.064l-.061.055c-.045.041-.111.037-.152-.008-.039-.045-.037-.111.008-.152l.061-.055c.088-.082.203-.121.315-.121.127,0,.256.053.348.154.082.088.121.203.121.315,0,.127-.053.256-.154.348l-.369.334h.416c.061,0,.108.049.108.109Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.604,38.561v1.153c0,.061-.051.107-.109.107-.061,0-.107-.047-.107-.107v-.961l-.078.045c-.018.012-.037.016-.055.016-.037,0-.072-.02-.092-.055-.033-.049-.016-.117.035-.147l.24-.143s.006-.002.008-.004c.004,0,.006-.004.01-.006.004,0,.008-.002.012-.002.002-.002.006-.002.008-.002.004-.002.01-.002.014-.002h.022s.006.002.008.002c.006,0,.008.002.012.004.002,0,.006,0,.008.002.006.004.008.006.012.006.002.002.004.004.008.006.002.002.006.004.008.006.004.002.006.006.008.008.002.002.004.004.006.008.002.002.006.006.008.008l.002.004s.002.004.002.006c.002.004.004.006.004.01.002.004.002.008.004.01,0,.004.002.008.002.01,0,.006,0,.01.004.014v.006Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.852,39.138c.002-.18.047-.342.133-.467.082-.125.209-.217.363-.217.15,0,.279.092.362.217.084.125.131.287.131.467,0,.178-.047.342-.131.467-.082.123-.211.217-.362.217-.154,0-.281-.094-.363-.217-.086-.125-.131-.289-.133-.467ZM221.624,39.138c0-.141-.039-.264-.094-.348-.057-.082-.121-.121-.182-.119-.061-.002-.127.037-.186.119-.055.084-.094.207-.094.348,0,.139.039.264.094.346.059.084.125.121.186.121s.125-.037.182-.121c.055-.082.094-.207.094-.346Z",
    style: {
      fill: "#1a2e35"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.094,44.35c0-.262.213-.473.475-.473.246,0,.448.186.471.424t.002.004c.002.037.004.074.004.111,0,.131-.02.272-.068.401-.049.129-.129.252-.252.334-.082.055-.182.088-.293.092-.061.002-.109-.043-.113-.104-.002-.059.045-.107.106-.113.074-.002.133-.023.184-.055.049-.033.09-.078.123-.137.01-.016.018-.033.025-.051-.057.025-.121.039-.188.039-.262,0-.475-.211-.475-.473ZM219.311,44.35c0,.141.115.258.258.258s.256-.117.256-.258c0-.143-.113-.256-.256-.256s-.258.113-.258.256Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69,44.414c.096.094.143.219.143.342s-.047.248-.143.344c-.094.094-.219.143-.344.143-.123,0-.248-.049-.342-.143-.043-.043-.043-.113,0-.156.043-.043.113-.043.156,0,.051.051.117.076.186.076s.135-.025.188-.076c.053-.053.078-.119.078-.188s-.025-.135-.078-.186c-.051-.053-.117-.076-.186-.078-.031.002-.061-.012-.08-.035t-.002-.002c-.045-.043-.045-.111-.004-.156l.199-.203h-.317c-.061,0-.109-.049-.109-.111,0-.061.049-.109.109-.109h.577c.062,0,.111.049.111.109,0,.02-.006.037-.014.053-.006.01-.012.02-.02.027l-.246.254c.051.023.098.055.137.096Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.401,50.323c0,.061-.049.108-.109.108h-.02v.149c0,.061-.047.107-.108.107s-.107-.047-.107-.107v-.149h-.616c-.023,0-.047-.006-.067-.023-.049-.037-.055-.104-.018-.15l.723-.899s.002-.002.004-.004c.002-.002.004-.004.006-.008.006-.002.008-.004.01-.006.002-.002.006-.004.008-.006.004-.002.006-.004.012-.004.002-.004.004-.006.008-.006.002-.002.006-.002.012-.004.002,0,.006,0,.008-.002h.033s.006.002.01.002c.002.002.008.002.012.004.002,0,.006.002.008.002.004.004.008.006.01.008.004.002.006.004.01.006,0,0,.002,0,.002.002.002,0,.006.002.006.004.004.004.006.006.008.008.002.002.004.006.006.008.002.002.004.004.008.01,0,.002.002.006.004.008.002.004.002.006.004.012,0,.002.002.006.002.008.002.004.002.006.002.012,0,.004.002.006.002.01v.795h.02c.061,0,.109.049.109.107ZM240.057,49.733l-.389.483h.389v-.483Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.51,50.222c0,.256-.209.465-.465.465-.258,0-.469-.209-.469-.465,0-.162.082-.305.209-.389-.041-.053-.065-.121-.065-.193,0-.176.145-.321.324-.321.176,0,.321.145.321.321,0,.072-.023.141-.064.193.125.084.209.227.209.389ZM221.297,50.222c0-.139-.113-.254-.252-.254-.141,0-.254.115-.256.254.002.139.115.252.256.252.139,0,.252-.113.252-.252ZM220.934,49.639c0,.061.049.111.111.111.059,0,.107-.051.107-.111,0-.059-.049-.108-.107-.108-.063,0-.111.049-.111.108Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.176,53.972c.096.094.143.219.143.344,0,.123-.049.248-.143.342-.094.096-.219.143-.342.143h-.004c-.121,0-.248-.047-.34-.143-.045-.041-.045-.111,0-.156.041-.043.113-.043.156,0,.051.053.117.078.188.078.066,0,.135-.025.186-.078.051-.051.078-.119.078-.186,0-.07-.025-.137-.078-.188-.051-.053-.117-.076-.186-.076-.066,0-.137.023-.188.076-.043.043-.113.043-.156,0-.008-.008-.014-.018-.021-.025,0-.004,0-.006-.002-.006,0-.004-.002-.008-.004-.01,0-.006-.002-.01-.002-.014,0-.002-.002-.002-.002-.004-.002-.012-.002-.023,0-.033l.059-.506c.006-.033.023-.061.049-.078.004-.002.006-.002.008-.004.002-.002.004-.002.006-.004.016-.008.031-.012.051-.012h.576c.062,0,.111.049.111.111,0,.059-.049.109-.111.109h-.481l-.023.193c.043-.012.088-.018.131-.018.123,0,.248.047.342.143Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.472,53.582l-.489,1.155c-.016.041-.055.064-.1.064-.012,0-.027-.002-.041-.008-.055-.025-.08-.088-.059-.141l.422-1.002h-.504c-.059,0-.107-.051-.107-.109,0-.061.049-.107.107-.107h.67c.006,0,.012,0,.02.002.014.002.027.01.041.016.002.002.004.004.006.006.004.002.006.004.008.008.002.004.006.006.008.008.002.004.004.006.006.008.002.002.004.008.004.01.002.004.004.006.008.01,0,.002.002.008.002.01.002.004.002.006.004.01.002.014.002.029,0,.043-.002.008-.004.014-.006.02Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.943,55.663c0,.262-.213.473-.475.473-.246,0-.448-.186-.471-.424t-.002-.004c-.002-.037-.004-.074-.004-.111,0-.131.02-.272.068-.401.049-.129.129-.252.252-.334.082-.055.182-.088.293-.092.061-.002.109.043.113.104.002.059-.045.107-.106.113-.074.002-.133.023-.184.055-.049.033-.09.078-.123.137-.01.016-.018.033-.025.051.057-.025.121-.039.188-.039.262,0,.475.211.475.473ZM230.726,55.663c0-.141-.115-.258-.258-.258s-.256.117-.256.258c0,.143.113.256.256.256s.258-.113.258-.256Z",
    style: {
      fill: "#1a2e35"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvitesAdded);
export default __webpack_public_path__ + "static/media/NoInvitesAdded.2b80fdea241a8d0fe179cac84f73148d.svg";
export { ForwardRef as ReactComponent };